/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-did-update-set-state */
import PropTypes from 'prop-types';
import * as queryString from 'query-string';
import React from 'react';
import { connect } from 'react-redux';

import config from '../../../config';
import * as loginPopUpActions from '../../actions/login-popup-actions';
import * as messagingActions from '../../actions/messaging-actions';
import * as actions from '../../actions/search-actions';
import requestLocation from '../../components/hocs/RequestLocation';
import withStatsig from '../../components/hocs/withStatsig';
import head from '../../components/Meta';
import { isLoginPopUpNeeded, titles, userParams } from '../../components/PopUps/LoginPopUpWrapper/LoginPopUp/utils';
import ShareUrlFooter from '../../components/Search/ShareUrlFooter';
import { POWER6_KEYS } from '../../utils/constants';
import styles from './search.scss';
import SearchResults from './SearchResults';
import EventSearchResults from './SearchV2/EventSearchResults';

import AdWrapper from '../../components/Ads/AdWrapper';
import { AdTypes } from '../../utils/types';

const filterTypes = {
    PLAYERS: 'players',
    EVENTS: 'events',
    CLUBS: 'clubs',
    COLLEGES: 'colleges',
    HIGH_SCHOOLS: 'highSchools',
    FLEX_LEAGUES: 'flexLeagues',
    TEAM_LEAGUES: 'teamLeagues',
    PRO_TENNIS_TOUR: 'proTennisTour',
    ADULT_TEAM_CLUBS: 'adultTeamClubs',
    PAID_HITS: 'paidHits',
    PAID_HIT_CLUBS: 'paidHitClubs',
    JUNIOR_CIRCUITS: 'juniorCircuits',
    COLLEGE_CIRCUITS: 'collegeCircuits',
    JUNIOR_REGIONALS: 'juniorRegionals',
    CAMPS: 'camps',
};

class SearchPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            actionPerformed: false,
        };
        this.handleShowLoginPopUp = this.handleShowLoginPopUp.bind(this);
        this.sendMessageToUser = this.sendMessageToUser.bind(this);
    }

    UNSAFE_componentWillMount() {
        const parsed = queryString.parse(this.props.location.search);
        const { checkGate, featureGates } = this.props;
        const isRostersRolloutEnabled = checkGate && featureGates ? checkGate(featureGates.ROSTERS_ROLLOUT) : false;
        const power6SortField = isRostersRolloutEnabled
            ? POWER6_KEYS.ACTIVE_ROSTER
            : POWER6_KEYS.SCHOOL;

        this.props.setSearchPageType({
            searchPageType: 'search',
        });
        // Initialize school sorting BEFORE applying filters to ensure sort is set before search
        this.props.initializeSchoolSorting(power6SortField);
        this.props.applySearchFilters({
            tours: {},
            regionSearch: parsed?.regionSearch,
            ...(parsed.type && { type: parsed.type }), // Preserve type if it exists in URL
        });
        this.props.fetchPrismicContent();
    }

    componentDidUpdate() {
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.showPopup && !this.state.actionPerformed) {
            this.handleShowLoginPopUp(parsed.type);
            this.setState({
                actionPerformed: true,
            });
        }
    }

    handleShowLoginPopUp(type) {
        let actionMethod;
        switch (type) {
            case 'morefilters':
            case 'signup':
            default:
                actionMethod = () => this.props.updateFiltersApplied(true);
                break;
        }
        const userParamsNeeded = [
            userParams.CLAIMED_PROFILE,
        ];
        if (isLoginPopUpNeeded(this.props.auth, userParamsNeeded)) {
            const popupData = {
                userParamsNeeded,
                titles: titles.SEARCH_PAGE,
                performAction: actionMethod,
                type, // should be sent back as query while redirecting from facebook to perform proper action
            };
            this.props.showLoginPopUp(popupData);
        } else if (actionMethod) {
            actionMethod();
        }
    }

    async sendMessageToUser(recipient) {
        const { auth } = this.props;

        if (recipient?.memberId && auth?.user?.id !== recipient.memberId) {
            this.props.msgSetNewConv(true);
            this.props.msgAddRecipient(recipient);
            this.props.history.push(`/inbox`);
        }
    }

    render() {
        const { search, auth, searchConfig, showAds, checkGate, featureGates } = this.props;
        const parsed = queryString.parse(this.props.location.search);
        const isEventSearchV2 = checkGate(featureGates.EVENT_SEARCH_V2) && parsed?.type === 'events';

        const claimedPlayerUrl = auth?.user?.claimedPlayer ? `${config.appHost}/players/${auth.user.claimedPlayer.playerId}` : null;
        const filters = this.props.search.filters || {};
        const isPowerUser = this.props.auth.user?.isPowered;
        const filterType = filters?.type ?? '';
        const showStickyAd = showAds && searchConfig?.showSticky;
        const showLeaderboardAd = showAds && searchConfig?.showLeaderboard;

        const ctaTexts = {
            players: {
                title: 'Share Your Profile',
                subTitle: 'Have your friends check out your rating and results',
                urlText: claimedPlayerUrl,
                url: claimedPlayerUrl,
            },
            events: {
                title: 'Invite Your Tennis Club!',
                subTitle: 'UTR Sports Clubs can create level-based events, post scores and more',
                urlText: 'I would love for our club to join UTR Sports! Please sign up at https://universaltennis.typeform.com/to/IlAe2w',
                url: 'https://universaltennis.typeform.com/to/IlAe2w',
            },
            clubs: {
                title: 'Invite Your Tennis Club! ',
                subTitle: 'UTR Sports Clubs can create level-based events, post scores and more',
                urlText: 'I would love for our club to join UTR Sports! Please sign up at https://universaltennis.typeform.com/to/IlAe2w',
                url: 'https://universaltennis.typeform.com/to/IlAe2w',
            },
        };

        // eslint-disable-next-line no-shadow
        const typeDisplay = (filterType) => {
            const paidHits = 'paidHits';
            const paidHitClubs = 'paidHitClubs';
            switch (filterType) {
                case 'clubs':
                    return 'Clubs';
                case 'players':
                    return 'Players';
                case 'events':
                    return 'Events';
                case 'colleges':
                    return 'Colleges';
                case 'highSchools':
                    return 'High schools';
                case 'flexLeagues':
                    return 'Flex Leagues';
                case 'teamLeagues':
                    return 'Tam Leagues';
                case 'proTennisTour':
                    return 'Pro Tennis Tour';
                case 'adultTeamClubs':
                    return 'Adult League Teams';
                case paidHits:
                    return 'Paid Hits';
                case paidHitClubs:
                    return 'Paid Hitters';
                case 'juniorCircuits':
                    return 'Junior Circuits';
                case 'collegeCircuits':
                    return 'College Circuits';
                case 'juniorRegionals':
                    return 'Junior Regionals';
                case 'camps':
                    return 'Camps';
                default:
                // do nothing
            }
            return false;
        };

        return (
            <div className={styles.searchPage}>
                {head({
                    title: 'Search the UTR Sports database',
                    description: 'Use UTR Sports’s advanced search filters to locate players, events, clubs, colleges and high schools',
                    keywords: 'ITA Summer Circuit, Men’s tennis rankings, Women’s tennis rankings',
                    image: `https://www.${config.siteBaseUrl}/img/utr_sports/utr-sports-logo.svg`,
                    imageWidth: '930',
                    imageHeight: '395',
                })}
                {showLeaderboardAd && (
                    <div className="d-flex jcc mt40">
                        <AdWrapper type={AdTypes.LEADERBOARD_ONE} data-testid="search.ad.leaderboard" />
                    </div>
                )}
                <div className="section sub-header d-block d-md-none">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="content">
                                    {this.props.search.query
                                        ? (
                                            <h6 className="mt16 mb16 search-subheader-mobile" data-testid="search.page.mobile-results-heading">
                                                <span className="text-medium" data-testid="search.page.mobile-results-heading.label">Search {filterType ? typeDisplay(filterType) : 'Showing'} for</span> &quot;{this.props.search.query}&quot;
                                            </h6>
                                        )
                                        : <h6 className="mt16 mb16 search-subheader-mobile" data-testid="search.page.mobile-results-heading">SEARCH {filterType ? typeDisplay(filterType) : ''} </h6>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section sub-header d-none d-md-block">
                    <div className="container pt16 mb8">
                        <div className="row">
                            <div className="col">
                                <div className="content" />
                            </div>
                        </div>
                    </div>
                </div>
                {isEventSearchV2 ? (
                    <EventSearchResults {...this.props} />
                ) : (
                    <SearchResults
                        {...this.props}
                        handleShowLoginPopUp={this.handleShowLoginPopUp}
                        sendMessage={this.sendMessageToUser}
                    />
                )}
                {
                    search.pageLoadedOnce > 0 && !search.isLoading && isPowerUser && filterType in ctaTexts &&
                    (
                        ((filterType === filterTypes.PLAYERS && !claimedPlayerUrl) || filterType === filterTypes.CLUBS || filterType === filterTypes.EVENTS) ? null // don't show if no claimed player
                            : (
                                <>
                                    <div className="search-footer-buffer" />
                                    <ShareUrlFooter
                                        buttonText="COPY LINK"
                                        urlText={ctaTexts[filterType].urlText}
                                        url={ctaTexts[filterType].url}
                                        title={ctaTexts[filterType].title}
                                        subTitle={ctaTexts[filterType].subTitle}
                                    />
                                </>
                            )
                    )
                }
                {showStickyAd && (
                    <AdWrapper type={AdTypes.STICKY} data-testid="search.ad.sticky" />
                )}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setSearchPageType: (searchPageType) => {
            dispatch(actions.setSearchPageType(searchPageType));
        },
        updateSearchQuery: (query) => {
            dispatch(actions.updateQuery(query));
        },
        changeFilterInputs: (filters) => {
            dispatch(actions.changeFilterInputs(filters));
        },
        updateFiltersApplied: (reSearch) => {
            dispatch(actions.updateFiltersApplied(reSearch, 'searchPage'));
        },
        applySearchFilters: (filters, reSearch) => {
            dispatch(actions.applySearchFilters(filters, reSearch, 'searchPage'));
        },
        clearFilters: (type, reSearch) => {
            dispatch(actions.clearFilters(type, reSearch));
        },
        undoFilterChange: () => {
            dispatch(actions.undoFilterChange());
        },
        setTypeSorting: ({ type, field, direction }) => {
            dispatch(actions.setTypeSorting({ type, field, direction }));
        },
        initializeSchoolSorting: (sortField) => {
            dispatch(actions.initializeSchoolSorting(sortField));
        },
        reSearch: () => {
            dispatch(actions.search(null, 'searchPage'));
        },
        loadMore: (type) => {
            const paidHits = 'paidHits';
            const paidHitClubs = 'paidHitClubs';
            switch (type) {
                case 'flexLeagues':
                    dispatch(actions.loadFlexLeagues());
                    break;
                case 'teamLeagues':
                    dispatch(actions.loadTeamLeagues());
                    break;
                case 'proTennisTour':
                    dispatch(actions.loadProTennisTourEvents());
                    break;
                case 'events':
                    dispatch(actions.loadEvents());
                    break;
                case 'clubs':
                    dispatch(actions.loadClubs());
                    break;
                case 'highSchools':
                    dispatch(actions.loadHighSchools());
                    break;
                case 'colleges':
                    dispatch(actions.loadColleges());
                    break;
                case 'adultTeamClubs':
                    dispatch(actions.loadAdultTeamClubs());
                    break;
                case paidHits:
                    dispatch(actions.loadPaidHitEvents());
                    break;
                case paidHitClubs:
                    dispatch(actions.loadPaidHitClubs());
                    break;
                case 'juniorCircuits':
                    dispatch(actions.loadJuniorCircuits());
                    break;
                case 'collegeCircuits':
                    dispatch(actions.loadCollegeCircuits());
                    break;
                case 'juniorRegionals':
                    dispatch(actions.loadJuniorRegionals());
                    break;
                case 'camps':
                    dispatch(actions.loadCamps());
                    break;
                default:
                    dispatch(actions.loadPlayers());
                    break;
            }
        },
        clearGlobalSearch: (clearGlobalSearch) => {
            dispatch(actions.clearGlobalSearch(clearGlobalSearch));
        },
        fetchPrismicContent: () => {
            dispatch(actions.fetchPrismicContent());
        },
        showLoginPopUp: data => dispatch(loginPopUpActions.showLoginPopUp(data)),
        msgAddRecipient: member => dispatch(messagingActions.addRecepient({ member })),
        msgSetNewConv: member => dispatch(messagingActions.setNewConv({ member })),
    };
}

function mapStateToProps({ auth, search, coreUI }) {
    return { auth, search, coreUI };
}

SearchPage.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    search: PropTypes.shape({
        filterInputs: PropTypes.shape({
            startDate: PropTypes.shape({
                isSame: PropTypes.func,
            }),
        }),
        events: PropTypes.shape({
            hits: PropTypes.arrayOf(PropTypes.shape({})),
            total: PropTypes.number,
        }),
    }),
    searchConfig: PropTypes.shape({
        showLeaderboard: PropTypes.bool,
        showSticky: PropTypes.bool,
    }),
    showAds: PropTypes.bool,
};

SearchPage.defaultProps = {
    search: {
        filterInputs: {
            startDate: {
                isSame: () => { },
            },
        },
        events: {
            hits: [],
            total: 0,
        },
    },
    searchConfig: {
        showLeaderboard: false,
        showSticky: false,
    },
    showAds: false,
};

export default withStatsig(requestLocation(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(SearchPage),
));
